import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, watch } from 'vue';
import BaseLayout from '@/components/layout.vue';

// https://zhuanlan.zhihu.com/p/462298873

export default {
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      if (navigator.userAgent.match(/Mobi/i) || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) {
        // 当前设备是移动设备
        const meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0';
        document.head.appendChild(meta);
      }
      window.addEventListener('beforeunload', function (e) {
        window.scrollTo(0, 0);
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(BaseLayout, null, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      });
    };
  }
};